import ActionsForm from '@/shared/mixins/actionsForm'
import usermanagement from '@/shared/http/repositories/realestate/usermanagement'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default{
  mixins: [ActionsForm],
  data () {
    return {
      headTable: ['NOME', 'CPF', 'RG', 'CRECI', 'UF CRESCI', 'STATUS', 'DT. DE CADASTRO', ''],
      usersArray: [],
      filter: localStoreHelper.gestao.cliente() || {},
      isFilter: false

    }
  },
  methods: {
    selectUser () {
      this.$emit('selectUser')
    },
    deleteUser () {
      this.$emit('deleteUser')
    },
    validalocalStoreHelper () {
      if (localStoreHelper.gestao.cliente() != null) {
        this.isFilter = true
      }
    },
    onLoad () {
      this.validalocalStoreHelper()
      if (this.isFilter) {
        usermanagement.GetCorretoresByFiltro(this.$refs.tableUsersGrid.pagingLimit, this.$refs.tableUsersGrid.pagingIndex, this.filter)
          .then(res => {
            if (res.status === 200) {
              let newUsersArray = res.data.data
              let newResponse = res
              this.usersArray = newUsersArray
              this.$refs.tableUsersGrid.LoadAllByData(newResponse)
            }
          })
          .catch(() => {})
        return
      }
      usermanagement.GetAllCorretores(this.$refs.tableUsersGrid.pagingLimit, this.$refs.tableUsersGrid.pagingIndex)
        .then(res => {
          this.usersArray = res.data.data
          this.$refs.tableUsersGrid.LoadAllByData(res)
        })
        .catch(() => {})
    },
    searchWithFilter (filter, iFilter) {
      this.filter = filter
      this.filter.usuarioid = this.filter.usuario.value
      this.isFilter = filter
      if (!this.filter) {
        this.$refs.tableUsersGrid.pagingIndex = 1
        this.$refs.tableUsersGrid.currentPage = 1
      }
      usermanagement.GetCorretoresByFiltro(this.$refs.tableUsersGrid.pagingLimit, this.$refs.tableUsersGrid.pagingIndex, filter)
        .then(res => {
          if (res.status === 200) {
            let newUsersArray = res.data.data
            let newResponse = res
            this.usersArray = newUsersArray
            this.$refs.tableUsersGrid.LoadAllByData(newResponse)
          }
        })
        .catch(() => {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/users/components/RealtorTable/RealtorTable.js